import { createWebHistory, createRouter } from 'vue-router';
import { reactive } from 'vue';
import * as api from '@/api';

import LayoutHome from '@/layout/home';
import Login from '@/views/login';
import AIPrompt from '@/views/ai/prompt';
import AIChat from '@/views/ai/chat';
import AIIssue from '@/views/ai/issue';

const routes = [
    {
        path: '/',
        redirect: '/ai/prompt',
    },
    {
        path: '/login',
        component: Login,
        meta: { requireLogin: false },
    },
    {
        path: '/ai',
        component: LayoutHome,
        children: [
            { path: 'prompt', component: AIPrompt },
            { path: 'chat', component: AIChat },
            { path: 'issue', component: AIIssue },
        ],
        meta: { requireLogin: true },
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeResolve((to, from, next) => {
    api.profile()
        .then(res => {
            to.userInfo = reactive(res.data);
            next();
        })
        .catch(res => {
            if (res.code == 407 && to.meta.requireLogin) {
                router.replace({ path: '/login' });
            } else {
                to.userInfo = null;
                next();
            }
        });
});

export default router;
